var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 11.0086C16.0006 13.2097 14.2333 14.9928 12.0322 15.0006H12.0243H4.20585C2.01259 15.0006 0.22168 13.2255 0.22168 11.0244V11.0165C0.22168 11.0165 0.226413 7.5246 0.232725 5.76841C0.233514 5.43863 0.612208 5.25401 0.870193 5.45914C2.74473 6.9463 6.09695 9.65791 6.13877 9.69341C6.69892 10.1423 7.40897 10.3956 8.1348 10.3956C8.86063 10.3956 9.57068 10.1423 10.1308 9.68473C10.1726 9.65712 13.4499 7.02677 15.3529 5.51516C15.6116 5.30924 15.9919 5.49385 15.9927 5.82284C16.0006 7.56562 16.0006 11.0086 16.0006 11.0086Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5882 2.90847C14.905 1.62091 13.5607 0.798828 12.0806 0.798828H4.20693C2.72686 0.798828 1.3825 1.62091 0.699276 2.90847C0.546221 3.19643 0.618804 3.5554 0.873633 3.75895L6.73155 8.44449C7.1418 8.77585 7.63884 8.94074 8.13587 8.94074C8.13903 8.94074 8.14139 8.94074 8.14376 8.94074C8.14613 8.94074 8.14928 8.94074 8.15165 8.94074C8.64869 8.94074 9.14572 8.77585 9.55597 8.44449L15.4139 3.75895C15.6687 3.5554 15.7413 3.19643 15.5882 2.90847Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailX);
export default __webpack_public_path__ + "static/media/email_x.492e96744167bce7945777f2f01b6aa4.svg";
export { ForwardRef as ReactComponent };